module.exports = __webpack_public_path__ + "img/logo.1abcc03d.png";